<ng-container *t="let t">
    <div class="main-container">
        <h3 class="tab-header" mat-dialog-title i18n="@@PCpleaseProvidePCF" t="PCpleaseProvidePCF">Please Provide a Primary Contact Form</h3>
        <div style="margin-left: 35px;">
            <div>
                <p i18n="@@PCFesignpopuptwo" t="PCFesignpopuptwo">
                    You are currently the assigned Primary Contact for Tesla.
                    You are responsible for managing contacts for your organization’s
                    use of the Tesla Supplier Relationship Management Portal and will
                    have profile standards to uphold. Additionally, you will have financial
                    detail and other critical data access.
                </p>
                <p i18n="@@PCFesignpopupthree" t="PCFesignpopupthree">Currently, the following functionalities are not
                    available:</p>
                <ul>
                    <li i18n="@@PCFesignpopupfour" t="PCFesignpopupfour">Change functionality to manage all critical data in
                        your Tesla Supplier Profile</li>
                    <li i18n="@@PCFesignpopupfive" t="PCFesignpopupfive">No finance detail access, including invoice reports
                        and/or e-Invoicing</li>
                    <li i18n="@@PCFesignpopupsix" t="PCFesignpopupsix">Validation of your email domain when submitting
                        inquiries to Tesla</li>
                    <li i18n="@@PCFesignpopupseven" t="PCFesignpopupseven">Other related access to the Supplier Relationship
                        Management Portal</li>
                </ul>
            </div>
        </div>
        <div style="margin-left: 35px;" *ngIf="isSupplierRemitToAddressChina">
            <p i18n="@@PCFisSupplierRemitToAddressChina" t="PCFisSupplierRemitToAddressChina"><b><u>To Enable Above
                        Functionalities:</u></b></p>
            <p i18n="@@PCFisSupplierRemitToAddressChinacontaint" t="PCFisSupplierRemitToAddressChinacontaint">Download the
                Primary Contact Form via the below link. Once signed, upload the completed form and click ‘Submit' to
                forward the form to Tesla for review.</p>
            <p>
                <span>
                    <button i18n="@@PCFdownloadform" t="PCFdownloadform" tsl-button color="black" size="medium"
                        (click)="downloadPCFTemplate()" outline>Download Form</button>
                    <button i18n="@@PCFuploadform" t="PCFuploadform" tsl-button color="black" filled size="medium"
                        (click)="onDocumentAdding()">Upload Signed Form</button>
                </span>
            </p>
            <div style="margin-left: 10px;" class="row" *ngIf="isDocumentAdding">
                <div fxFlex="95">
                    <tsl-file-drop [inputText]="translate.get('choose a file')" [hintText]="translate.get('Drag and Drop a File or ')" #fileDrop multiple="false" (fileChange)="onFileAdd($event)"> </tsl-file-drop>
                    <mat-hint>
                        <a target="_blank" [href]="guideLinesUrl" i18n="@@a6a0a4da3e30cfc3f654b9d1d89d33d00f192841"
                            t="a6a0a4da3e30cfc3f654b9d1d89d33d00f192841">Guidelines Page</a>
                    </mat-hint>
                </div>
            </div>
            <div *ngIf="document" style="padding-bottom:10px;">
                <div class="column" fxFlex="50">
                    <tsl-label class="label" i18n="@@Document" t="Document">Document</tsl-label>
                </div>
            </div>
            <div *ngIf="document">
                <tsl-label class="label">{{ document.FileName }}
                    <span (click)="clearFile()">
                        <tsl-icon>delete</tsl-icon>
                    </span></tsl-label>
            </div>
        </div>
        <div style="margin-left: 35px;" *ngIf="!isSupplierRemitToAddressChina">
            <p i18n="@@PCFisSupplierRemitToAddressNONChina" t="PCFisSupplierRemitToAddressNONChina"><b><u>To Enable Above
                        Functionalities:</u></b></p>
            <p i18n="@@PCFisSupplierRemitToAddressNONChinacontaint" t="PCFisSupplierRemitToAddressNONChinacontaint">Complete
                the Primary Contact Form via the below link. Once signed, navigate back to this pop-up and click ‘Submit’ to
                forward the form to Tesla for review.</p>
            <p>
                <span>
                    <button i18n="@@a84e7d440f86f695b551728b3e78597b74dffa01" t="a84e7d440f86f695b551728b3e78597b74dffa01"
                        tsl-button color="black" filled size="medium" (click)="publishForESign()">Click here to
                        E-Sign</button>
                    <div style="margin-left: 15px; font-size: 12px; margin-top: 10px;">
                        <label><b i18n="@@17d7af030707b5bdf0145619ea5f6bb5fdbfd8af"
                                t="17d7af030707b5bdf0145619ea5f6bb5fdbfd8af">E-Sign Status:
                            </b></label><label>{{ esignAgreementStatus }}</label>
                    </div>
                </span>
            </p>
        </div>
        <div class="actions right">
            <button i18n="@@Cancel" t="Cancel" tsl-button color="black" size="medium" (click)="close()" outline>Cancel</button>
            <button i18n="@@Submit" t="Submit" tsl-button color="blue" filled size="medium"
                (click)="submitPCF()">Submit</button>
        </div>
    </div>
</ng-container>